import { sendPOST } from "../utils/comm.js";

const progressSend = (progress) => {
  if (false) return Promise.resolve(true);
  else {
    // Comment-out this code entirely once we determine we no longer want progress tracking
    if (!progress.dateValue) {
      const d = new Date();
      progress = {
        ...progress,
        dateValue: d.getTime(),
        dateLocale: d.toLocaleString(),
      };
    }
    return sendPOST("/progress", progress); // return a promise
  }
};

export { progressSend };
